/* unplugin-vue-components disabled */import script from "./CustomMultipleProductSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomMultipleProductSelect.vue?vue&type=script&setup=true&lang=ts"

import "./CustomMultipleProductSelect.vue?vue&type=style&index=0&id=98720be2&lang=less"
import "./CustomMultipleProductSelect.vue?vue&type=style&index=1&id=98720be2&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98720be2"]])

export default __exports__